import "../bootstrap";
import initSliders from "../components/initSliders.js";
import initVideo from "../components/initVideo.js";
import initTabs from "../components/initTabs.js";
import initModals from "../components/initModals.js";
import initLightbox from "../components/initLightbox.js";


document.addEventListener("DOMContentLoaded", () => {

    const {
        initHeroSlider,
        initFeaturesSlider,
        initHomeProductsSlider,
        initArticlesSlider,
        initPhotosSlider,
        initVideosSlider,
        initTestimonialsSlider,
        initModalProductSlider,
    } = initSliders();

    initHeroSlider();
    initFeaturesSlider();
    initHomeProductsSlider();
    initArticlesSlider();
    initPhotosSlider();
    initVideosSlider();
    initTestimonialsSlider();
    initModalProductSlider();

    initVideo();
    initTabs();
    initModals();
    initLightbox();


});
